export const countriesRadioOptions = [
  { id: "all", key: "all", name: "All" },
  { id: "select", key: "select", name: "Select Countries" },
];

export const defaultCatalogItemDetails = {
  announceable: true,
  backfillable: true,
  brandName: "",
  categories: [],
  claimUrl: "",
  claimUrlForceTrailingSlash: false,
  countries: [],
  currency: {},
  denominations: [
    {
      amount: "",
      bufferable: false,
      externalIdentifier: "",
    },
  ],
  description: "",
  distributionMethod: undefined,
  effectiveAt: "",
  externalIdentifier: "",
  feePercentage: 0,
  flatFeeInUsdCents: 0,
  forAllCountries: false,
  fullName: "",
  id: undefined,
  language: "en",
  logo: {
    altText: "logo",
    id: undefined,
    imageBase64String: undefined,
    imageContentType: undefined,
    imageName: "",
    imageUrl: "",
  },
  provider: undefined,
  redemptionLocation: "",
  redemptionMethod: {},
  state: "",
  twitterHandle: "",
  warnings: [],
  website: "",
};

export const defaultRequiredFields = [
  "brandName",
  "categories",
  "currency",
  "denominations",
  "distributionMethod",
  "fullName",
  "logo",
  "provider",
];

export const defaultMessageOptions = {
  isOpen: false,
  message: "",
  type: "info",
};

// NOTE: We also have methods "axomo" and "custom" but those do not apply to the global catalog items
export const distributionMethods = [
  { id: "cash_out", key: "cash_out", name: "Cash Out" },
  { id: "donation", key: "donation", name: "Donation" },
  { id: "gift_card", key: "gift_card", name: "Gift Card" },
];

export const denominationStatesDisplay = {
  active: "Active",
  archived: "Archived",
  inactive: "Inactive",
};

export const inactiveReasonsDisplay = {
  admin_disabled: "Admin disabled",
  discontinued: "Discontinued",
  needs_attention: "Needs attention",
  out_of_stock: "Out of stock",
  system_disabled: "System disabled",
};

export const manageCatalogTableHeaders = [
  {
    accessor: "checkbox",
    align: "center",
    className: "checkboxColumn",
    text: "Select",
  },
  {
    accessor: "statusIcon",
    align: "center",
    className: "statusColumn",
    text: "",
  },
  {
    accessor: "brandName",
    align: "left",
    text: "Display Name",
    width: "270px",
  },
  {
    accessor: "externalIdentifier",
    align: "left",
    text: "ID",
  },
  {
    accessor: "providerDisplay",
    align: "left",
    text: "Provider",
  },
  {
    accessor: "countriesDisplay",
    align: "left",
    text: "Country",
    width: "185px",
  },
  {
    accessor: "denominationsDisplay",
    align: "left",
    text: "Denominations",
  },
  {
    accessor: "denominationsNote",
    align: "left",
    text: "Denominations Note",
    width: "165px",
  },
  {
    accessor: "distributionMethodDisplay",
    align: "left",
    text: "Reward Type",
    width: "115px",
  },
  {
    accessor: "editIcon",
    align: "center",
    text: "",
  },
];

export const providers = [
  { id: "amazon", key: "amazon", name: "Amazon" },
  { id: "bonusly", key: "bonusly", name: "Bonusly Points Boost" },
  { id: "bulk_donation", key: "bulk_donation", name: "Bonusly Bulk Donation" },
  { id: "cadooz", key: "cadooz", name: "Cadooz" },
  { id: "paypal", key: "paypal", name: "PayPal" },
  { id: "tango_card", key: "tango_card", name: "Tango" },
  { id: "tremendous", key: "tremendous", name: "Tremendous" },
];

export const externalIdentifierProviders = [
  "cadooz",
  "tango_card",
  "tremendous",
];

export const legacyIdProviders = ["bulk_donation"];

export const redemptionMethodProviders = [
  "amazon",
  "bonusly",
  "cadooz",
  "paypal",
  "tango_card",
  "tremendous",
];

export const redemptionLocationMethods = [
  "rr_number",
  "rr_number_rr_pin_printable_with_website",
  "rr_number_rr_pin_printable",
];

export const websiteRedemptionMethods = [
  "rr_number_with_website",
  "rr_number_rr_pin_with_website",
  "rr_number_rr_pin_printable_with_website",
  "rr_pin_with_website",
  "rr_number_rr_code_rr_pin_with_website",
];

export const websiteDistributionMethods = ["donation"];

export const twitterHandleDistributionMethods = ["donation"];
